import { create } from 'zustand';
import { notificationService } from '../services';

const useNotificationStore = create((set, get) => ({
  notifications: [],
  unreadCount: 0,
  isLoading: false,
  pagination: {
    total: 0,
    page: 1,
    limit: 20,
    totalPages: 0
  },
  
  fetchNotifications: async (params = {}) => {
    set({ isLoading: true });
    try {
      const response = await notificationService.getNotifications(params);
      set({
        notifications: response.data,
        pagination: response.pagination,
        isLoading: false
      });
    } catch (error) {
      set({ isLoading: false });
      throw error;
    }
  },
  
  fetchUnreadCount: async () => {
    try {
      const count = await notificationService.getUnreadCount();
      set({ unreadCount: count });
    } catch (error) {
      console.error('Failed to fetch unread count:', error);
    }
  },
  
  markAsRead: async (id) => {
    await notificationService.markAsRead(id);
    set((state) => ({
      notifications: state.notifications.map((n) =>
        n._id === id ? { ...n, isRead: true } : n
      ),
      unreadCount: Math.max(0, state.unreadCount - 1)
    }));
  },
  
  markAllAsRead: async () => {
    await notificationService.markAllAsRead();
    set((state) => ({
      notifications: state.notifications.map((n) => ({ ...n, isRead: true })),
      unreadCount: 0
    }));
  },
  
  deleteNotification: async (id) => {
    await notificationService.deleteNotification(id);
    set((state) => ({
      notifications: state.notifications.filter((n) => n._id !== id)
    }));
  },
  
  addNotification: (notification) => {
    set((state) => ({
      notifications: [notification, ...state.notifications],
      unreadCount: state.unreadCount + 1
    }));
  },
  
  clearAll: async () => {
    await notificationService.deleteAll();
    set({ notifications: [], unreadCount: 0 });
  }
}));

export default useNotificationStore;
